import { combineReducers } from 'redux'

export const makeSubStore = (storeKey, actions, reducers, initialState, initialiseState = () => {}) => {
  // TODO: Improve type-checking for arguments here
  if (!storeKey || !actions || !(typeof reducers === 'function') || !initialState) {
    throw Error('Invalid arguments passed to makeSubStore method')
  }
  return { storeKey, actions, reducers, initialState, initialiseState }
}

export const combineSubStores = (substores) => {
  const extractField = (key) => Object.keys(substores).reduce((acc, cur) => ({ ...acc, [substores[cur].storeKey]: substores[cur][key] }), {})
  const actions = extractField('actions')
  const reducers = combineReducers(extractField('reducers'))
  const initialState = extractField('initialState')
  const initialiseState = extractField('initialiseState')
  const storeKeys = Object.keys(substores).reduce((acc, cur) => ({ ...acc, [cur]: substores[cur].storeKey }), {})
  return { initialiseState, actions, reducers, initialState, storeKeys }
}
